const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || "";
const POSTHOG_HOST = (process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com").replace(/\/+$/, "");
const STORAGE_DISTINCT_ID = "factlify_posthog_distinct_id";

const isEnabled = () => Boolean(POSTHOG_KEY);

const getDistinctId = () => {
  let id = localStorage.getItem(STORAGE_DISTINCT_ID);
  if (!id) {
    id = `ph_${Math.random().toString(36).slice(2)}_${Date.now()}`;
    localStorage.setItem(STORAGE_DISTINCT_ID, id);
  }
  return id;
};

const postCapture = async (payload) => {
  if (!isEnabled()) return;
  try {
    await fetch(`${POSTHOG_HOST}/capture/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (_) {
    // Analytics must never break user flows.
  }
};

export const initAnalytics = () => {
  if (!isEnabled()) return;
  getDistinctId();
};

export const identifyAnalyticsUser = (user) => {
  if (!isEnabled() || !user?.user_id) return;
  return postCapture({
    api_key: POSTHOG_KEY,
    event: "$identify",
    distinct_id: getDistinctId(),
    properties: {
      $set: {
        user_id: user.user_id,
        email: user.email || "",
        name: user.name || "",
      },
    },
  });
};

export const trackEvent = (event, properties = {}) => {
  if (!isEnabled()) return;
  return postCapture({
    api_key: POSTHOG_KEY,
    event,
    distinct_id: getDistinctId(),
    properties: {
      ...properties,
      // Every funnel event must be segmentable by workspace.
      workspace_id: localStorage.getItem("factlify_workspace") || "",
      app: "factlify",
      ts: new Date().toISOString(),
    },
  });
};

/** Stripe plan change / checkout intent — emits both names for dashboards that expect either. */
export const trackPlanUpgradeIntent = (properties = {}) => {
  if (!isEnabled()) return;
  const base = { ...properties, app: "factlify", ts: new Date().toISOString() };
  postCapture({
    api_key: POSTHOG_KEY,
    event: "plan_upgrade_click",
    distinct_id: getDistinctId(),
    properties: base,
  });
  postCapture({
    api_key: POSTHOG_KEY,
    event: "plan_upgrade",
    distinct_id: getDistinctId(),
    properties: base,
  });
};
